import { fromJS } from 'immutable';

import {
  saveJobProfileRoutine,
  removeJobProfileRoutine,
  fetchJobProfilesRoutine,
} from '../routines';
import { remove, updateOrAdd } from './helper';

const initialState = fromJS({
  jobProfiles: {},
  jobProfile: {},
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchJobProfilesRoutine.REQUEST:
      return state.set('loading', true);
    case fetchJobProfilesRoutine.SUCCESS:
      return state.set('jobProfiles', fromJS(action.payload.response));
    case fetchJobProfilesRoutine.FAILURE:
      return state.set('error', action.error).set('loading', false);

    case saveJobProfileRoutine.SUCCESS:
      return state.updateIn(['jobProfiles', 'data'], updateOrAdd(fromJS(action.payload.response.data)));
    case removeJobProfileRoutine.SUCCESS:
      return state.updateIn(['jobProfiles', 'data'], remove(fromJS(action.payload.request)));

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/jobprofiles.js